import { getUserAccessToken } from '@/utils/account/getUserAccessToken';
import {
  autofillOrganizationDetails as autofillOrganizationDetailsServer,
  changeOrganizationName as changeOrganizationNameServer,
  fetchCurrentOrganization as fetchCurrentOrganizationServer,
  upsertOrganizationDetails as upsertOrganizationDetailsServer,
  getOrganizationDetails as getOrganizationDetailsServer,
  getOrganizationMembers as getOrganizationMembersServer,
} from '@/actions/organizations';

export const fetchCurrentOrganization = async () => {
  const userAccessToken = await getUserAccessToken();
  return fetchCurrentOrganizationServer(userAccessToken);
};

export const changeOrganizationName = async (data: any) => {
  const userAccessToken = await getUserAccessToken();
  return await changeOrganizationNameServer(userAccessToken, data);
};

export const autofillOrganizationDetails = async (id: string) => {
  const userAccessToken = await getUserAccessToken();
  return await autofillOrganizationDetailsServer(userAccessToken, id);
};

export const upsertOrganizationDetails = async (id: string, data: any) => {
  const userAccessToken = await getUserAccessToken();
  return await upsertOrganizationDetailsServer(userAccessToken, id, data);
};

export const getOrganizationDetails = async (id: string) => {
  const userAccessToken = await getUserAccessToken();
  return await getOrganizationDetailsServer(userAccessToken, id);
};

export const getOrganizationMembers = async (id: string) => {
  const userAccessToken = await getUserAccessToken();
  return await getOrganizationMembersServer(userAccessToken, id);
};
